<div class="fundraising-container">

    <ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

      <div class="search-row align-center">
        <button style="box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);" class="btn dark-btn" (click)="create()">
          New Campaign
        </button>
       <div class="input-with-icon align-row">
          <div class="input-icon align-center"><i class="flaticon-search"></i></div>
          <input
            type="text"
            placeholder="Search"
            (keyup)="search()"
            [(ngModel)]="searchText"
            class="searchtext"
        />
        </div>
        <div class="input-with-icon align-row">
            <select
                [(ngModel)]="selectedTeam"
                (ngModelChange)="filterByTeam()"
                class="searchtext">
                <option selected value='0'>
                    -- Filter events by team --
                </option>
                <option *ngFor="let team of teams; let i = index;" [value]="team.teamId">
                    {{ team.name }}
                </option>
            </select>
          </div>
      </div>
      <div *ngIf="ppws" class="fundraising-table">
        <div class="data-row" *ngFor="let ppw of displayItems">
          <div class="data-row-content" >
            <div class="content-cell">
              <div style="justify-content: space-between;" class="cell-row">
                <h3 class="fundraiser-title">{{ppw.event.name}}</h3>
                <div class="dropdown">
                  <div class="dots">
                    <img/>
                  </div>
                  <div class="dropdown-content">
                    <a (click)="startEvent(ppw.event.eventId)" class="start-tab" *ngIf="ppw.event.status === 1" href="#">Start Campaign!</a>
                    <a (click)="openCompletionModal(ppw.pledgePerWinId)" class="start-tab" *ngIf="ppw.event.status ===2" href="#">Add Completed Game</a>
                    <a (click)="cancelEvent(ppw.event.eventId)" class="delete-tab" *ngIf="ppw.event.status === 1" href="#">Cancel Campaign</a>
                    <a (click)="completeEvent(ppw.event.eventId)" class="start-tab" *ngIf="ppw.event.status === 2" href="#">Complete Campaign</a>

                    <a (click)="clone(ppw.event.eventId)" href="#">Clone</a>
                    <a *ngIf="ppw.event.status === 1 || ppw.event.status === 2" (click)="edit(ppw.event.eventId)" href="#">Edit</a>
                    <a *ngIf="ppw.event.status > 2" (click)="edit(ppw.event.eventId)" href="#">View</a>
                    <!-- <a (click)="openDetailsModal(ppw.event.eventId)" href="#">Details</a> -->
                    <a (click)="updateSortOrder(ppw.pledgePerWinId)" href="#">Change Sort Order</a>
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <div class="block-icon blk"><i class="flaticon-share"></i><span>{{ppw.event.eventType.formattedName}}</span></div>
                <div *ngIf="ppw.event.status === 1" class="block-icon status blu"><i class="flaticon-calendar"></i><span>SCHEDULED</span></div>
                <div *ngIf="ppw.event.status === 4"  class="block-icon status red"><i class="flaticon-cancel"></i><span>CANCELED</span></div>
                <div *ngIf="ppw.event.status === 2"  class="block-icon status blu-grn"><i class="flaticon-exclamation-2"></i><span>IN PROGRESS</span></div>
                <div *ngIf="ppw.event.status === 3 || ppw.event.status === 5"  class="block-icon status grn"><i class="flaticon-calendar-1"></i><span>COMPLETED</span></div>
                <div *ngIf="ppw.event.status === 6"  class="block-icon status red"><i class="flaticon-exclamation-2"></i><span>PROCESSING ERROR</span></div>
              </div>
              <div class="cell-row">
                <div>
                  <div class="info-container">
                    <span class="info-content">{{ppw.team.name}}</span>
                    <span class="info-title">Team</span>
                  </div>
                  <div class="info-container">
                    <span class="info-content">{{ppw.event.vendor.name}}</span>
                    <span class="info-title">School</span>
                  </div>
                </div>
                <div>
                  <div class="info-container">
                    <span *ngIf="ppw.event.status === 1 || ppw.event.status === 4" class="info-content">- -</span>
                    <span *ngIf="ppw.event.status !== 1 && ppw.event.status !== 4" class="info-content">{{ ppw.orderTotals?.total / 100 | currency }}</span>
                    <span class="info-title">Total Raised - Gross</span>
                  </div>
                  <div class="info-container">
                    <span *ngIf="ppw.event.status === 1 || ppw.event.status === 4" class="info-content">- -</span>
                    <span *ngIf="ppw.event.status !== 1 && ppw.event.status !== 4" class="info-content">{{ ppw.orderTotals?.net / 100 | currency }}</span>
                    <span class="info-title">Total Raised - Net</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!displayItems.length"> No Pledge Per Win Campaigns to show, click 'New Campaign' to begin</div>
      </div>
    </div>
